/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentLinkOpen: "shipment-link-open",
} as const;
